export const WORKSPACE_COMMON_TAG = 'workspace-common';
export const DEFAULT_RIGHT_SIDEBAR_WIDTH = 450;
export const DEFAULT_LEFT_SIDEBAR_WIDTH = 320;
export const GROUP_BY_OPTIONS = ['none', 'type', 'date'];
export const SORT_BY_OPTIONS = ['ascending', 'descending'];

export const ATTR_EXPERIENCED_NAME = 'Experienced';
export const ATTR_PRESENT_NAME = 'Present';
export const ATTR_CURRENT_NAME = 'Current';
export const BASE_ATTRIBUTE_NAMES = [ATTR_PRESENT_NAME, ATTR_EXPERIENCED_NAME, ATTR_CURRENT_NAME];
export const ATTR_TYPE_DAY = 'day';
export const ATTR_TYPE_YEAR = 'year';
export const ATTR_TYPE_MONTH = 'month';
export const ATTR_VAL_YES = 'Yes';
export const ATTR_VAL_NO = 'No';
export const MAX_VISIT_OCC_ID_LENGTH_TO_SHOW = 30;
